module.exports = __webpack_public_path__ + "static/blog-top-96720ac1e4c4816eeba0f6bcc6d79c8c.png";